/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?: string;
};

const SvgComponent: FC<IProps> = ({ width = 40, height = 28, fill = "none" }) => (
  <svg width={width} height={height} className="bg-[#1F72CD] rounded-lg" viewBox="0 0 70 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Type=Amex">
      <path id="AMEX" fillRule="evenodd" clipRule="evenodd" d="M12.5493 17.374L6 31.8675H13.8405L14.8125 29.5566H17.0342L18.0062 31.8675H26.6364V30.1038L27.4054 31.8675H31.8696L32.6386 30.0665V31.8675H50.587L52.7695 29.6167L54.813 31.8675L64.0317 31.8861L57.4617 24.6612L64.0317 17.374H54.956L52.8315 19.5833L50.8523 17.374H31.3268L29.6501 21.1149L27.9341 17.374H20.11V19.0777L19.2396 17.374H12.5493ZM39.3516 19.4321H49.6584L52.8108 22.8373L56.0648 19.4321H59.2172L54.4275 24.6592L59.2172 29.826H55.9218L52.7695 26.3813L49.4989 29.826H39.3516V19.4321ZM41.8968 23.484V21.5854V21.5836H48.328L51.1342 24.6198L48.2036 27.6727H41.8968V25.6H47.5197V23.484H41.8968ZM14.0664 19.4321H17.8883L22.2324 29.2602V19.4321H26.4191L29.7745 26.4788L32.8668 19.4321H37.0326V29.8322H34.4978L34.4771 21.6828L30.7817 29.8322H28.5142L24.7981 21.6828V29.8322H19.5836L18.595 27.5006H13.254L12.2675 29.8301H9.47358L14.0664 19.4321ZM14.166 25.3452L15.9256 21.1918L17.6832 25.3452H14.166Z" fill="white"/>
    </g>
  </svg>);

export default SvgComponent;
